import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import useAuth from '../../hooks/useAuth';

const InstallSnackbar = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [open, setOpen] = useState(false);

  const {auth} = useAuth();

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setOpen(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        setDeferredPrompt(null);
        setOpen(false);
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  if(['Maker', 'Checker', 'Authorizer'].includes(auth?.roles)){
    return (
      <Snackbar
        open={open}
        message="Install this app for a better experience!"
        action={
          <Button color="secondary" size="small" onClick={handleInstallClick}>
            Install
          </Button>
        }
        onClose={handleClose}
        autoHideDuration={6000}
      />
    );
  } else {
    return null;
  }
};

export default InstallSnackbar;
